import { Grid } from "@mui/material";
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
 
import TextInput from "../../../components/common/TextInput";
import RadioButtonGroup from "../../../components/common/RadioButtonGroup";
import Scheduler from "../../../components/Scheduler/Scheduler";
import DatePicker from "../../../components/common/DatePicker";
import dayjs from "dayjs";
 
const SchedulerConfigurator = (props) => {
  const today = dayjs();
 
  const handleStartDateChange = (newValue) => {
    if (newValue && dayjs(newValue).isValid()) {
      props.setScheduledStartDate(dayjs(newValue).format('YYYY-MM-DD'));
      props.setBtnDisabled(!newValue || !props.scheduledTime);
    } else {
      props.setScheduledStartDate(null);
    }
  };
 
  const handleStartTimeChange = (newValue) => {
    if (newValue && dayjs(newValue).isValid()) {
      props.setScheduledTime(dayjs(newValue).format('HH:mm:ss'));
      props.setBtnDisabled(!props.scheduledStartDate || !newValue);
    } else {
      props.setScheduledTime(null);
    }
  }
  return (
    <>
      <Grid
        container
        xs={12}
        mt={2}
        sx={{
          padding: "0 15px",
          borderRadius: "10px",
          flexDirection: "column",
        }}
      >
        <h4>Scheduling Parameters</h4>
        <form>
          <Grid
            item
            md={4}
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              "& .MuiFormControl-root": { width: "100%" },
              "& .MuiFormLabel-root": { fontSize: "14px" },
              "& .MuiInputBase-root>Input": { height: "80% !important" },
            }}
          >
            <label className="label-position" htmlFor="hierarchy">
              Label*
            </label>
            <TextInput
              label="Label"
              name="prodCriticalItem"
              value={props.formData?.prodCriticalItem}
              onChange={props.handleChange}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            mt={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              "& .MuiFormControl-root": { width: "100%" },
              "& .MuiFormLabel-root": { fontSize: "14px" },
              "& .MuiInputBase-root>Input": { height: "80% !important" },
            }}
          >
            <label className="label-position" htmlFor="hierarchy">
              Description
            </label>
            <TextInput
              label="Description"
              name="materialTypeDesc"
              value={props.formData?.materialTypeDesc}
              onChange={props.handleChange}
            />
          </Grid>
          <Grid
            item
            xs={6}
            mt={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              "& .MuiFormControl-root": { width: "100%" },
              "& .MuiFormLabel-root": { fontSize: "14px" },
              "& .MuiInputBase-root>Input": { height: "80% !important" },
            }}
          >
            <label className="label-position" htmlFor="hierarchy">
              Schedule Type
            </label>
            <RadioButtonGroup
              props={[
                {
                  label: "Single-Run",
                  value: "Single-Run",
                  labelPlacement: "end",
                  size: "small",
                },
                {
                  label: "One-Time-Schedule",
                  value: "One-Time-Schedule",
                  labelPlacement: "end",
                  size: "small",
                },
                {
                  label: "Recurring",
                  value: "Recurring",
                  labelPlacement: "end",
                  size: "small",
                },
              ]}
              value={props?.scheduleType}
              onChange={props?.handleRadioChange}
              name="scheduleType"
            />
          </Grid>
          {props?.scheduleType === "Recurring" ? (
            <Grid
              item
              xs={12}
              mt={2}
              sx={{
                display: "flex",
                flexDirection: 'column'
              }}
            >
              <p style={{fontSize:'14px'}}><b>Note: </b>To guarantee your job runs even if the date falls on a different day of the week, select all days (Mon-Sun) when using 'Week' or 'Year' with a specific day of the month.</p>
              <Scheduler scheduleValue={props.scheduleValue} setScheduleValue={props.setScheduleValue} />
              <Grid item md={8} xs={12} mt={2}
                sx={{
                  display: "flex",
                  paddingTop: "5px !important",
                  "& .MuiFormControl-root": { width: "80%" },
                  "& .MuiFormLabel-root": { fontSize: "14px" },
                }}
              >
                <Grid item md={4} xs={12} style={{marginBottom:10}}>
                  <DatePicker
                      name="scheduledStartDate"
                      label="Scheduled Start Date*"
                      value={props?.scheduledStartDate ? dayjs(props?.scheduledStartDate) : null}
                      onChange={handleStartDateChange}
                      minDate={today}
                    />
                </Grid>
              </Grid>
            </Grid>
          ):
          props?.scheduleType === "One-Time-Schedule" ? (
            <Grid item md={8} xs={12} mt={2}
              sx={{
                display: "flex",
                paddingTop: "5px !important",
                "& .MuiFormControl-root": { width: "80%" },
                "& .MuiFormLabel-root": { fontSize: "14px" },
              }}
            >
              <Grid item md={4} xs={12}>
                <DatePicker
                    name="scheduledStartDate"
                    label="Scheduled Start Date*"
                    value={props?.scheduledStartDate ? dayjs(props?.scheduledStartDate) : null}
                    onChange={handleStartDateChange}
                    minDate={today}
                  />
              </Grid>
              <Grid item md={4} xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      label="Scheduled Start Time*"
                      ampm={false}
                      views={['hours', 'minutes', 'seconds']}
                      value={props?.scheduledTime ? dayjs(props?.scheduledTime, 'HH:mm:ss') : null}
                      onChange={handleStartTimeChange}
                      sx={{height: '20px'}}
                      slotProps={{ textField: { size: 'small' } }}
                    />
                  </LocalizationProvider>
              </Grid>
            </Grid>
          ) :
          ''
          }
        </form>
      </Grid>
    </>
  );
};
 
export default SchedulerConfigurator;